import {UserService} from "../services/user.service";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {TokenService} from "../services/token.service";
import {environment} from "../../../environments/environment";
import {RuoloUtenteEnum} from "../../model/enum/TipologiaUtenteEnum";

const useNamLogin = environment.useNamLogin;
const namAuthCodeUrl = `${environment.nam.urlAuthz}?client_id=${environment.nam.clientId}&response_type=code&redirect_uri=${environment.nam.redirectUri}&scope=${environment.nam.scope}`;

// Controllo che l'utente sia loggato su NAM
export const loginGuard = () => {
  if (useNamLogin) {
    const tokenService = inject(TokenService)
    if (tokenService.getAccessToken() != null) {
      return true;
    } else {
      sessionStorage.setItem('url', window.location.href);
      window.location.href = namAuthCodeUrl;
      return false;
    }
  } else {
    return true;
  }
}

// Controllo che l'utente ha un profilo Claims Platform per poter accedere all'applicativo
export const profileGuard = async () => {
  const route = inject(Router)
  const user = await inject(UserService).getUser();
  return (user !== undefined && !user.ruoli.includes("")) ? true : route.createUrlTree(['unauthorized']);
};

// Controllo che l'utente da il ruolo Admin per poter accedere a pagine specifiche dell'applicativo
export const adminGuard = async () => {
  const route = inject(Router)
  const user = await inject(UserService).getUser();
  return (user !== undefined && user.ruoli.includes('admin')) ? true : route.createUrlTree(['']);
}

export const smsGuard = async () => {
  const route = inject(Router)
  const user = await inject(UserService).getUser();
  return (user !== undefined && user.ruoli.includes('sms_sender')) ? true : route.createUrlTree(['']);
}

export const ibanCheckGuard = async () => {
  const route = inject(Router)
  const user = await inject(UserService).getUser();
  return (user !== undefined && user.ruoli.includes('check_iban_user')) ? true : route.createUrlTree(['']);
}


export const smsAdminGuard = async () => {
  const route = inject(Router);
  const user = await inject(UserService).getUser();
  return (user !== undefined && user.ruoli.includes('sms_admin')) ? true : route.createUrlTree(['']);
}

export const aniaGuard = async () => {
  const route = inject(Router);
  const userService = inject(UserService);
  const user = await userService.getUser();
  const isAniaUser = userService.determineSicAniaUser();
  return (user !== undefined && isAniaUser) ? true : route.createUrlTree(['']);
}
export const aniaAndminGuard = async () => {
  const route = inject(Router)
  const user = await inject(UserService).getUser();
  return (user !== undefined && user.ruoli.includes('ania_admin')) ? true : route.createUrlTree(['']);
}

export const smartSummaryGuard = async () => {
  const route = inject(Router);
  const userService = inject(UserService);
  const user = await userService.getUser();
  return ((user !== undefined && user.ruoli.includes(RuoloUtenteEnum.UTENTE_SMART_SUM.toString())) || ((user !== undefined && user.ruoli.includes(RuoloUtenteEnum.SMART_SUMMARY_ADMIN.toString())) ? true : route.createUrlTree([''])));
}
export const adminSmartSummaryGuard = async () => {
  const route = inject(Router);
  const userService = inject(UserService);
  const user = await userService.getUser();
  return (user !== undefined && user.ruoli.includes(RuoloUtenteEnum.SMART_SUMMARY_ADMIN.toString())) ? true : route.createUrlTree(['']);
}
